import { Box } from '@mantine/core';
import { ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

export const LayoutSidebar = ({ children }: Props) => (
  <Box
    sx={theme => ({
      flex: '0 0 100%',
      order: 1,
      borderBottom: `1px solid ${theme.colors.gray[1]}`,
      [`@media (min-width: ${theme.breakpoints.sm}px)`]: {
        flex: 0,
        order: 2,
      },
    })}
  >
    {children}
  </Box>
);
